import React from "react";
import { Col, Row } from "react-bootstrap";
import { ThemeButton } from '../../buttons/ThemeButton';
import Langs from "../../../app/lang/langs";

/**
 * TabNavigationButtons - Renders Previous/Next/Save navigation buttons
 * at the bottom of each tab, handling both mobile and desktop layouts.
 *
 * @param {object} props
 * @param {number} props.isMobile - 1 = desktop, 2 = mobile, 3 = tablet
 * @param {string} props.mode - 'edit' or null (creation mode)
 * @param {function} [props.onPrevious] - Handler for Previous button. If null, no Previous button shown.
 * @param {function} props.onNext - Handler for Next/Save button.
 * @param {string|JSX.Element} [props.nextLabel] - Label for the next/save button. Defaults based on mode.
 * @param {string|JSX.Element} [props.previousLabel] - Label for the previous button.
 * @param {boolean} [props.showPreviousInEdit] - Whether to show Previous in edit mode (default false).
 */
export default function TabNavigationButtons({
    isMobile,
    mode,
    onPrevious,
    onNext,
    nextLabel,
    previousLabel,
    showPreviousInEdit = false,
}) {
    const defaultNextLabel = mode === "edit" ? <Langs str="SAVE" /> : <Langs str="Next" />;
    const defaultPreviousLabel = <Langs str="Previous" />;
    const resolvedNextLabel = nextLabel !== undefined ? nextLabel : defaultNextLabel;
    const resolvedPreviousLabel = previousLabel !== undefined ? previousLabel : defaultPreviousLabel;

    const showPrevious = onPrevious && (mode !== "edit" || showPreviousInEdit);

    if (isMobile === 2) {
        // Mobile layout
        if (showPrevious) {
            return (
                <Row className="mt-3 d-flex justify-content-around" style={{ width: '100%' }}>
                    <Col xs={5} className="d-flex justify-content-start">
                        <ThemeButton title={resolvedPreviousLabel} active={true} onClick={onPrevious} style={{ width: '48%' }} />
                    </Col>
                    <Col xs={5} className="d-flex justify-content-end">
                        <ThemeButton title={resolvedNextLabel} active={true} onClick={onNext} style={{ width: '48%' }} />
                    </Col>
                </Row>
            );
        }
        return (
            <Row className="mt-3 d-flex justify-content-center" style={{ width: '100%' }}>
                <Col xs={6} className="d-flex justify-content-center">
                    <ThemeButton title={resolvedNextLabel} active={true} onClick={onNext} style={{ width: '48%' }} />
                </Col>
            </Row>
        );
    }

    // Desktop / Tablet layout
    if (showPrevious) {
        return (
            <div>
                <div style={{ position: 'fixed', bottom: '1.5rem', left: '21rem', width: isMobile === 3 ? '20%' : '7%' }}>
                    <ThemeButton title={resolvedPreviousLabel} active={true} onClick={onPrevious} style={{ width: '100%' }} />
                </div>
                <div style={{ position: 'fixed', bottom: '1.5rem', right: isMobile === 3 ? '3rem' : '1.5rem', width: isMobile === 3 ? '20%' : '7%' }}>
                    <ThemeButton title={resolvedNextLabel} active={true} onClick={onNext} style={{ width: '100%' }} />
                </div>
            </div>
        );
    }
    return (
        <div>
            <div style={{
                position: 'fixed',
                bottom: '1.5rem',
                right: isMobile === 3 ? '3rem' : '1.5rem',
                width: isMobile === 3 ? '15%' : '7%'
            }}>
                <ThemeButton
                    title={resolvedNextLabel}
                    active={true}
                    onClick={onNext}
                    style={{ width: '100%' }}
                />
            </div>
        </div>
    );
}
